import { render, staticRenderFns } from "./numberEditor.vue?vue&type=template&id=6b5388d5"
import script from "./numberEditor.vue?vue&type=script&lang=js"
export * from "./numberEditor.vue?vue&type=script&lang=js"
import style0 from "./numberEditor.vue?vue&type=style&index=0&id=6b5388d5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports